import { EnumSchema } from '../metadata-schema';

export const Cijferkolomtype: EnumSchema = {
	"type": "string",
	"title": "Cijferkolomtype",
	"enum": [
		"Toets",
		"Advies",
		"Laatste periodegemiddelde",
		"Laatste gemiddelde",
		"Laatste rapportcijfer",
		"Periodegemiddelde",
		"Gemiddelde",
		"Rapportcijfer",
		"SE-cijfer",
		"CE-cijfer",
		"Eindcijfer"
	]
};
